import { CommonModule } from '@angular/common';
import { NgModule, ErrorHandler } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

import { RouterModule } from '@angular/router';
import { ErrorsHandler } from './errors-handler';
import { ForbiddenComponent } from './forbidden/forbidden.component';
import { GeneralErrorComponent } from './general-error/general-error.component';
import { NotFoundComponent } from './not-found/not-found.component';
import { UnauthorizedComponent } from './unauthorized/unauthorized.component';

@NgModule({
  imports: [
    CommonModule,
    TranslateModule,
    RouterModule,
  ],
  declarations: [GeneralErrorComponent, ForbiddenComponent, NotFoundComponent, UnauthorizedComponent],
  providers: [
    {
      provide: ErrorHandler,
      useClass: ErrorsHandler,
    },
  ],
})
export class ErrorsModule { }
